import * as Yup from 'yup';

/**
 * Checks for Australian phone number format.
 * Copied from enquiry form UI.
 * @param {string} input - The input to be checked.
 * @returns {boolean} True if the input matches Australian phone number format, otherwise false.
 */
export const australianFormatCheck = (input) => {
    if (!input) return false;

    // Only getting the number trimming special character and space
    const newVal = input
        .toString()
        .replace(/[^0-9+]/g, '')
        .trim();

    // Validation condition for non-Australian format
    if (newVal.length < 9) {
        return false;
    }
    if (newVal[0] === '+' && newVal[1] !== '6' && newVal[2] !== '1') {
        return true;
    }

    // Validation condition for Australian format
    if (newVal[0] !== '+' || (newVal[0] === '+' && newVal[1] === '6' && newVal[2] === '1')) {
        if (
            !/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/i.test(
                input
            )
        ) {
            return false;
        }
    }
    return true;
};

const contactNumberMessage = "Valid contact number with area code is required. International number must start with \"+\".";

export const enquiryValidationSchema = Yup.object({
    fullName: Yup.string().strict()
        .required("Full name is required.")
        .matches(/^(?!.*[.,'-]{2})[a-zA-Z\s.'-]*$/, "Numbers or any other symbols are not allowed.") // it does not accept special characters except hyphen(-), full stop(.) and apostrophe(')
        .matches(/^(?!\s{1}$)[a-zA-Z\s.'-]+(?:\s+[a-zA-Z\s.'-]+)+$/, "Full name is required.") // FirstName and LastName must be entered; it does not accept just the first name or a blank space.
        .matches(/^(?!.* {2,})[A-Za-z\s.'-]+$/, "Only one spacing is allowed.") // it does not allow more than one continuous space
        .max(80, "Oops, your full name is too long."), // only takes maximum 80 characters
    contactNumber: Yup.string().required(contactNumberMessage).test('contactNumber', contactNumberMessage, australianFormatCheck),
    emailAddress: Yup.string()
        .matches(/^(?!(?:\.\.|,|@)\.|@\.)[a-zA-Z0-9!"#$%&'*+\/=?^_`{|}~-](?:(?!\.\.|@)[a-zA-Z0-9!"#$%&'*+\/=?^_`{|}~-]|(?<=[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-])\.(?=[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-])|(?<=\.)\.(?=[^.])|(?<=\.)"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")+@(?:[a-zA-Z0-9-]+\.)+(?:[a-zA-Z]{2,}|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})$/, "Valid email address is required.")
        .required('Email address is required.'),
});